/**
 * useDebouncedValue — wartość opóźniona o `delay` ms od ostatniej zmiany (np. fraza z wiersza
 * „Szukaj…" pod nagłówkami listy, żeby nie wysyłać zapytania na każdy znak).
 *
 * Pierwsza wartość jest zwracana od razu (bez opóźnienia). Timer jest czyszczony przy zmianie
 * wartości i przy odmontowaniu. Wspólny dla listy faktur zakupu i sekcji kokpitu decyzji.
 */

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
